import I18n from 'i18n-js'
import { report } from './safe_report'

I18n.missingTranslation = (key) => {
  report(`missing translation in frontend: "${key}"`)
  return null
}

export default I18n
